// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2BbKw","headline":"styles_headline__3tJA4","buttonWrap":"styles_buttonWrap__iFqUc"};